import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import PDFViewer from "./PDFViewer";

const MediaViewerModal = ({ isOpen, onClose, src, title = "File Viewer" }) => {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        e.preventDefault();
        e.stopPropagation();
        onClose();
      }
    };
    if (isOpen) {
      window.addEventListener("keydown", handleKeyDown, true);
    }
    return () => window.removeEventListener("keydown", handleKeyDown, true);
  }, [isOpen, onClose]);

  if (!isOpen || !src || typeof document === "undefined") return null;

  const isPdf = /\.pdf($|\?)/i.test(src) || String(src).toLowerCase().includes("pdf") || String(title).toLowerCase().includes("pdf");

  return createPortal(
    <div
      className="fixed inset-0 flex items-center justify-center bg-black/80 backdrop-blur-sm p-2 sm:p-4 animate-fade-in"
      style={{ zIndex: 2147483000 }}
    >
      <div className="relative w-full max-w-5xl h-[90vh] bg-slate-900 rounded-2xl overflow-hidden shadow-2xl flex flex-col border border-slate-700">
        {/* Header */}
        <div className="flex items-center justify-between px-4 py-3 bg-slate-800 border-b border-slate-700 text-white">
          <div className="flex items-center gap-2">
            <span className="text-base font-bold text-blue-400">📄 {title}</span>
          </div>
          <div className="flex items-center gap-3">
            <a
              href={src}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-blue-600 hover:bg-blue-700 text-white text-xs font-semibold px-3 py-1.5 rounded-lg transition"
            >
              Open Original
            </a>
            <button
              onClick={onClose}
              className="text-slate-400 hover:text-white text-xl font-bold px-2 py-0.5 rounded-lg hover:bg-slate-700 transition"
            >
              ✕
            </button>
          </div>
        </div>

        {/* Media Content */}
        <div className="flex-1 overflow-auto p-4 flex items-center justify-center bg-slate-950/90">
          {isPdf ? (
            <div className="w-full h-full bg-white rounded-lg p-2 overflow-auto">
              <PDFViewer file={src} />
            </div>
          ) : (
            <img
              src={src}
              alt={title}
              className="max-w-full max-h-full object-contain rounded-lg shadow-xl"
            />
          )}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default MediaViewerModal;
